import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoOc: CultureInfo = {
  name: 'oc',
  displayName: 'Occitan',
  iso3LanguageCode: 'oci',
  iso2LanguageCode: 'oc',
  ietfLanguageTag: 'oc',
  parent: null
};
